import { Nav } from 'react-bootstrap';

import Placeholder from '@components/Placeholder/Placeholder';
import { useSettings } from '@hooks';
import useViewportSizing from '@hooks/useViewportSizing';

import './PatientDetailSidebar.scss';

interface PatientDetailSidebarProps {
  numOfOrders: number;
  numOfDocuments: number;
  hasPartnershipOrdering: boolean;
  loading: boolean;
  showPGxGuidance: boolean;
  showResultsSummary: boolean;
}

export const PatientDetailSidebar: React.FC<PatientDetailSidebarProps> = props => {
  const { hasPartnershipOrdering, loading, numOfOrders, numOfDocuments, showPGxGuidance, showResultsSummary } = props;

  const { isNateraProd } = useSettings();
  const { isDesktop } = useViewportSizing();

  const showRerequisitionOrdering = !isNateraProd;
  const extraSections = [showRerequisitionOrdering, showPGxGuidance, showResultsSummary].filter(Boolean).length;
  const numOfSections = 2 + extraSections;

  const handleSidebarClick = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`d-flex flex-row flex-lg-column patient-detail-sidebar${
        hasPartnershipOrdering ? ' has-partnership-ordering' : ''
      }`}
    >
      <Nav as='nav' aria-label='On this page' className='mt-0'>
        <ul className='d-flex flex-row flex-lg-column ps-0 mb-0 sections-navbar'>
          {loading ? (
            <>
              {Array.from(Array(numOfSections)).map((_, index) => (
                <li key={`menu-item-${index}`}>
                  <div className='px-3 py-2 sidebar-item-placeholder'>
                    <Placeholder size='lg' className='w-100' />
                  </div>
                </li>
              ))}
            </>
          ) : (
            <>
              {showResultsSummary && (
                <li key='resultsSummary'>
                  <Nav.Link
                    className='align-self-start'
                    eventKey='resultsSummary'
                    onClick={() => handleSidebarClick('resultsSummary')}
                  >
                    Results Summary
                  </Nav.Link>
                </li>
              )}

              <li key='orders'>
                <Nav.Link className='align-self-start' eventKey='orders' onClick={() => handleSidebarClick('orders')}>
                  Orders ({numOfOrders})
                </Nav.Link>
              </li>

              <li key='documents'>
                <Nav.Link
                  className='align-self-start'
                  eventKey='documents'
                  onClick={() => handleSidebarClick('documents')}
                >
                  Documents ({numOfDocuments})
                </Nav.Link>
              </li>
              {showRerequisitionOrdering && (
                <li key='newReports'>
                  <Nav.Link
                    className='align-self-start'
                    eventKey='newReports'
                    onClick={() => handleSidebarClick('newReports')}
                  >
                    {isDesktop ? 'New Reports Available for Ordering' : 'New Reports'}
                  </Nav.Link>
                </li>
              )}

              {showPGxGuidance && (
                <li key='pgxGuidance'>
                  <Nav.Link
                    className='align-self-start'
                    eventKey='pgxGuidance'
                    onClick={() => handleSidebarClick('pgxGuidance')}
                  >
                    PGx Medication Guidelines
                  </Nav.Link>
                </li>
              )}
            </>
          )}
        </ul>
      </Nav>
    </div>
  );
};
